import week from './week'
import month from './month'
import day from './day'

const views = {week, month, day}

export default views
